import { Route, Switch } from 'wouter';

import ServiceAddPage from './ServiceAddPage';
import ServiceEditPage from './ServiceEditPage';
import ServiceList from './ServicesList';

export default function ServicesPage() {
  return (
    <Switch>
      <Route path={'/add'} component={ServiceAddPage} />
      <Route path={'/:id'} component={ServiceEditPage} />
      <Route component={ServiceList} />
    </Switch>
  );
}
